import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from './api.service';
import { GridComponent } from '@progress/kendo-angular-grid';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GridSettingsService {
    constructor(
        private readonly api: ApiService,
        private readonly datePipe: DatePipe,
        private readonly toaster: ToastrService
    ) { }

    /** Save grid column visibility changes */
    saveGridSettings(columnEvent: GridComponent, tableName: string): Observable<any> {
        const currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        const columns = (columnEvent?.columns as any)?._results ?? [];
        const visibleFields = columns
            .filter((col: any) => !col?.hidden)
            .map((col: any) => col.field);

        const reqBody = {
            Id: 0,
            PersistString: JSON.stringify(visibleFields),
            TableName: tableName,
            DomainName: localStorage.getItem('UserName'),
            CreatedOn: currentDate,
            CreatedBy: localStorage.getItem('UserName'),
        };

        return this.api.AdminGridSettingAddData(reqBody).pipe(
            tap((res: any) => {
                if (res?.Success) {
                    this.toaster.success('Changes Saved');
                } else {
                    this.toaster.error('Changes Not Saved');
                }
            })
        );
    }

    /** Load and apply saved grid settings */
    applyGridSettings(api: ApiService, tableName: string, gridKendo: any): void {
        api.GetDomainName(localStorage.getItem('UserName'), tableName).subscribe((res: any) => {
            const data = res?.Data;
            if (data?.PersistString) {
                const displayColumns = JSON.parse(data.PersistString);
                const gridColumns = gridKendo.columns?._results ?? [];

                for (const column of gridColumns) {
                    column.hidden = !displayColumns.includes(column.field);
                }
            }
        });
    }
}
